import {
    ADD_COMMENT_FAILURE,
    ADD_COMMENT_SUCCESS,
    DELETE_COMMENT_FAILURE,
    DELETE_COMMENT_SUCCESS,
    GET_COMMENTS_FAILURE,
    GET_COMMENTS_PERMISSION_FAILURE,
    GET_COMMENTS_PERMISSION_SUCCESS,
    GET_COMMENTS_SUCCESS,
    UPDATE_COMMENT_FAILURE,
    UPDATE_COMMENT_SUCCESS,
} from "./actions";

const initialState = {
    commentsByRecordId: {},
    getCommentsResult: {},
    addCommentResult: {},
    updateCommentResult: {},
    deleteCommentResult: {},
    getCommentsPermissionResult: {},
    userCommentsPermission: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_COMMENTS_SUCCESS:
            const { recordId, comments } = action.payload;
            return {
                ...state,
                getCommentsResult: { success: true, error: null },
                commentsByRecordId: {
                    ...state.commentsByRecordId,
                    [recordId]: comments, // Store comments under the recordId key
                },
            };
        case GET_COMMENTS_FAILURE:
            return {
                ...state,
                getCommentsResult: { success: false, error: action.payload },
            };
        case ADD_COMMENT_SUCCESS: {
            const { recordId, comment } = action.payload;
            const currentRecordComments = state.commentsByRecordId[recordId] || { Items: [] };
            const newItems = [...currentRecordComments.Items, comment];
            return {
                ...state,
                addCommentResult: { success: true, error: null },
                commentsByRecordId: {
                    ...state.commentsByRecordId,
                    [recordId]: { ...currentRecordComments, Items: newItems },
                },
            };
        }
        case ADD_COMMENT_FAILURE:
            return {
                ...state,
                addCommentResult: { success: false, error: action.payload },
            };
        case UPDATE_COMMENT_SUCCESS: {
            const { recordId, comment } = action.payload || {};
            const nextState = {
                ...state,
                updateCommentResult: { success: true, error: null },
            };

            if (recordId && comment && state.commentsByRecordId[recordId]) {
                const currentRecordComments = state.commentsByRecordId[recordId];
                const updatedItems = currentRecordComments.Items.map((c) => (c.commentId === comment.commentId ? comment : c));
                nextState.commentsByRecordId = {
                    ...state.commentsByRecordId,
                    [recordId]: { ...currentRecordComments, Items: updatedItems },
                };
            }

            return nextState;
        }
        case UPDATE_COMMENT_FAILURE:
            return {
                ...state,
                updateCommentResult: { success: false, error: action.payload },
            };
        case DELETE_COMMENT_SUCCESS: {
            const { recordId, commentId } = action.payload;
            const currentRecordComments = state.commentsByRecordId[recordId];
            if (!currentRecordComments || !currentRecordComments.Items) {
                return {
                    ...state,
                    deleteCommentResult: { success: true, error: null },
                };
            }
            const filteredItems = currentRecordComments.Items.filter((c) => c.commentId !== commentId);
            return {
                ...state,
                deleteCommentResult: { success: true, error: null },
                commentsByRecordId: {
                    ...state.commentsByRecordId,
                    [recordId]: { ...currentRecordComments, Items: filteredItems },
                },
            };
        }
        case DELETE_COMMENT_FAILURE:
            return {
                ...state,
                deleteCommentResult: { success: false, error: action.payload },
            };
        case GET_COMMENTS_PERMISSION_SUCCESS:
            return {
                ...state,
                getCommentsPermissionResult: { success: true, error: null },
                userCommentsPermission: action.payload,
            };
        case GET_COMMENTS_PERMISSION_FAILURE:
            return {
                ...state,
                getCommentsPermissionResult: { success: false, error: action.payload },
                userCommentsPermission: null,
            };
        default:
            return state;
    }
};
